import { useMemo, useState } from 'react';
import { indexTopics } from '@/mocks/home';
import SectionHeading from './SectionHeading';

const tabs = ['全部', '视频合集', '音频实锤', '书面证据', '电子证据'];

export default function CollectionIndex() {
  const [active, setActive] = useState('全部');

  const list = useMemo(
    () => (active === '全部' ? indexTopics : indexTopics.filter((topic) => topic.tag === active)),
    [active],
  );

  return (
    <section id="index" className="hll-scroll-anchor w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          eyebrow="COLLECTION INDEX"
          title="合集索引 · 先看目录再挑素材"
          desc="所有黑料吃瓜网视频与图片按主题归成合集，编号排好、数量标明，先扫一遍目录就能定位想看的那一组。"
          actionLabel="查看完整索引"
          actionHref="#feed"
        />

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-12">
          <aside className="lg:col-span-4">
            <div className="rounded-lg border border-background-300/60 bg-background-100 p-6">
              <span className="font-label text-xs tracking-[0.28em] text-secondary-600">把素材收好</span>
              <p className="mt-4 font-heading text-4xl font-bold text-foreground-950">
                1,286
                <span className="ml-2 text-base font-medium text-foreground-500">个合集</span>
              </p>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                按主题分区，视频、图片、证据各自成列；黑料吃瓜网实锤与黑料吃瓜网证据类合集单独标号，方便逐条核对。
              </p>

              <div className="mt-6 flex flex-wrap gap-2">
                {tabs.map((tab) => (
                  <button
                    key={tab}
                    type="button"
                    onClick={() => setActive(tab)}
                    className={`cursor-pointer whitespace-nowrap rounded-full border px-3 py-1.5 text-xs transition-colors ${
                      active === tab
                        ? 'border-primary-500 bg-primary-500 text-background-50'
                        : 'border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600'
                    }`}
                  >
                    {tab}
                  </button>
                ))}
              </div>

              <div className="mt-6 rounded-md border border-accent-300 bg-accent-50 px-4 py-3">
                <p className="text-xs leading-relaxed text-accent-900">
                  小提示：担心错过更新？先把感兴趣的黑料吃瓜网高清合集记下编号，下次直接搜编号即可。
                </p>
              </div>
            </div>
          </aside>

          <div className="lg:col-span-8">
            <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-300/60 bg-background-50">
              {list.map((topic) => (
                <a
                  key={topic.id}
                  href="#feed"
                  className="group flex cursor-pointer items-center gap-4 p-4 transition-colors hover:bg-background-100 md:p-5"
                >
                  <span className="font-heading text-2xl font-bold text-background-400 transition-colors group-hover:text-primary-500 md:text-3xl">
                    {topic.no}
                  </span>
                  <div className="h-16 w-16 shrink-0 overflow-hidden rounded-md md:h-20 md:w-20">
                    <img
                      src={topic.image}
                      alt={`${topic.title} - 黑料吃瓜网合集`}
                      title={`${topic.title} 黑料吃瓜网资源`}
                      className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2">
                      <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] text-secondary-900">
                        {topic.tag}
                      </span>
                      <span className="text-[11px] text-foreground-400">{topic.count}</span>
                    </div>
                    <h3 className="mt-2 truncate font-heading text-base font-semibold text-foreground-950 md:text-lg">
                      {topic.title}
                    </h3>
                  </div>
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-background-300 text-foreground-500 transition-colors group-hover:border-primary-400 group-hover:text-primary-600">
                    <i className="ri-arrow-right-up-line text-base"></i>
                  </span>
                </a>
              ))}
              {list.length === 0 ? (
                <div className="p-8 text-center text-sm text-foreground-500">该分区暂未收录合集（演示）</div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}